module.exports = __webpack_public_path__ + "static/media/ori.ce0b2ab9.png";